'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLoadD = function IoLoadD(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.8 18.8c0.7 0 1.2 0.5 1.2 1.2s-0.5 1.3-1.2 1.3h-6.3c-0.7 0-1.2-0.6-1.2-1.3s0.5-1.2 1.2-1.2h6.3z m-20 1.2c0 0.7-0.6 1.3-1.3 1.3h-6.2c-0.8 0-1.3-0.6-1.3-1.3s0.5-1.2 1.3-1.2h6.2c0.7 0 1.3 0.5 1.3 1.2z m6.2 6.3c0.7 0 1.3 0.5 1.3 1.2v6.3c0 0.7-0.6 1.2-1.3 1.2s-1.2-0.5-1.2-1.2v-6.3c0-0.7 0.5-1.2 1.2-1.2z m0-21.3c0.7 0 1.3 0.5 1.3 1.3v6.2c0 0.7-0.6 1.3-1.3 1.3s-1.2-0.6-1.2-1.3v-6.2c0-0.8 0.5-1.3 1.2-1.3z m5.4 11.9c-0.3-0.6-0.2-1.4 0.5-1.7l5.4-3.2c0.6-0.3 1.4-0.1 1.7 0.5s0.1 1.4-0.5 1.7l-5.4 3.1c-0.6 0.4-1.4 0.2-1.7-0.4z m-10.8 6.2c0.3 0.7 0.2 1.4-0.5 1.7l-5.3 3.2c-0.7 0.3-1.5 0.1-1.8-0.5s-0.1-1.4 0.5-1.7l5.4-3.1c0.6-0.4 1.4-0.2 1.7 0.4z m10.2 2.8l3.2 5.3c0.3 0.7 0.1 1.5-0.5 1.8s-1.4 0.1-1.7-0.5l-3.1-5.4c-0.4-0.6-0.2-1.4 0.4-1.7s1.4-0.2 1.7 0.5z m-10.6-18.4l3.1 5.4c0.4 0.6 0.2 1.4-0.4 1.7s-1.4 0.2-1.7-0.5l-3.2-5.3c-0.3-0.7-0.1-1.5 0.5-1.8s1.4-0.1 1.7 0.5z m8.9 7.1c-0.6-0.3-0.8-1.1-0.4-1.7l3.1-5.4c0.3-0.6 1.1-0.8 1.7-0.5s0.8 1.1 0.5 1.8l-3.2 5.3c-0.3 0.7-1 0.8-1.7 0.5z m-6.2 10.8c0.6 0.3 0.8 1.1 0.4 1.7l-3.1 5.4c-0.3 0.6-1.1 0.8-1.7 0.5s-0.8-1.1-0.5-1.7l3.2-5.4c0.3-0.7 1-0.8 1.7-0.5z m15.6 0.4c0.6 0.3 0.8 1.1 0.5 1.7s-1.1 0.8-1.7 0.5l-5.4-3.2c-0.7-0.3-0.8-1.1-0.5-1.7s1.1-0.8 1.7-0.4z m-25-11.6c-0.6-0.3-0.8-1.1-0.5-1.7s1.1-0.8 1.8-0.5l5.3 3.2c0.7 0.3 0.8 1.1 0.5 1.7s-1.1 0.8-1.7 0.4z' })
        )
    );
};

exports.default = IoLoadD;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/load-d.js
// module id = 2338
// module chunks = 0